import styled from 'styled-components';

const sizes = {
  md: {
    height: '45px',
    'min-width': '164px'
  },
  sm: {
    height: '31px',
    padding: '8px 12px',
    fontSize: '12px',
    'font-weight': '500',
    'border-radius': '4px'
  },
  xs: {
    height: '27px',
    padding: '6px 12px',
    fontSize: '12px',
    'font-weight': '500',
    'border-radius': '4px'
  }
};

const variantStyles = {
  primary: {
    'background-color': '#228BE6',
    border: '1px solid #228BE6',
    color: '#fff'
  },
  outlined: {
    'background-color': '#fff',
    border: '1px solid #228BE6',
    color: '#228BE6'
  },
  unstyled: {
    color: '#228BE6'
  },
  'unstyled-gray': {
    color: '#868E96'
  },
  'outlined-gray': {
    'background-color': '#fff',
    border: '1px solid #CED4DA',
    color: '#141517'
  },
  'filled-red': {
    'background-color': '#FA5252',
    border: '1px solid #FA5252',
    color: '#fff'
  }
};

const varianHoverStyles = {
  primary: {
    'box-shadow':
      '0px 3px 7px 0px #6a69c633, 0px 13px 13px 0px #6a69c62b, 0px 29px 17px 0px #6a69c61a, 0px 51px 20px 0px #6a69c608, 0px 80px 22px 0px #6a69c600'
  },
  'filled-red': {
    'box-shadow':
      '0px 3px 7px 0px #6a69c633, 0px 13px 13px 0px #6a69c62b, 0px 29px 17px 0px #6a69c61a, 0px 51px 20px 0px #6a69c608, 0px 80px 22px 0px #6a69c600'
  },
  outlined: {
    'box-shadow':
      '0px 3px 7px 0px #6a69c633, 0px 13px 13px 0px #6a69c62b, 0px 29px 17px 0px #6a69c61a, 0px 51px 20px 0px #6a69c608, 0px 80px 22px 0px #6a69c600'
  }
};

export const ButtonStyled = styled.button`
  cursor: pointer !important;
  width: ${({ maxWidth }) => (maxWidth ? '100%' : 'auto')};
  border-radius: 4px;
  font-size: ${({ theme }) => theme.fonts?.label['font-size']};
  line-height: ${({ theme }) => theme.fonts?.label['line-height']};
  font-weight: ${({ theme }) => theme.fonts?.label['font-weight']};
  ${({ size }) => sizes[size]}
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: ${({ variant }) => (variant === 'secondary' ? '#fff' : 'none')};
  gap: ${({ withIcon }) => (withIcon ? '8px' : '0')};
  transition: 0.4s ease-in-out all;
  ${({ variant }) => variantStyles[variant]}

  &:hover {
    ${({ variant }) => varianHoverStyles[variant]}
  }

  &:disabled {
    background: #e9ecef !important;
    color: #909296 !important;
    cursor: default !important;
    border-color: #e9ecef !important;
    //opacity: 0.5;
    &:hover {
      box-shadow: none !important;
    }

    /* svg {
      path {
        fill: #909296 !important;
      }
    } */
  }
`;

export const LoaderWrapper = styled.div`
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
